import { PersonalizationPerson } from './personalization-person';

export interface PersonalizationAddition<T = Date> {
  type: 'PERSONALIZATION';
  persons: PersonalizationPerson<string, T>[];
}
